var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { apiUpdateRfpOfferSave } from '@/actions/rfpProOfferActions';
import { RfpProConfirmFormButton } from '@/components/modules/pages/rfp/professional/Button/RfpProConfirmFormButton';
import { RfpProOfferConfirmView } from '@/components/pages/rfp/professional/RfpProOfferConfirmView';
import Layout from '@/container/Layout';
import { notify } from '@/helpers/action';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useBoolState } from '@/hooks/state/useBoolState';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { getIsPublic, getDirectSaveValues, getPublicSaveValues, } from '@/utils/resources/rfp/rfpProOfferSave';
import { professionalRfpOfferCompletePath } from '@/utils/router/links';
const title = '入力内容の確認';
/**
 * コンサルタント：案件提案提出確認ページ全体を表示する
 */
export const RfpProOfferConfirmPage = (props) => {
    const { changeStepValue, initialValues, lockId, rfp } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const history = useNavigate();
    // ツールチップ 表示
    const { boolState: isShowConfirmModal, changeFalse: hideConfirmModal, changeTrue: showConfirmModal, } = useBoolState();
    /**
     * 保存処理
     */
    const onSubmit = useCallback((confirmFormValues) => __awaiter(void 0, void 0, void 0, function* () {
        changeStepValue({ confirm: true });
        const isPublic = getIsPublic(rfp.rfp_type, confirmFormValues);
        const data = {
            json: isPublic
                ? getPublicSaveValues(confirmFormValues)
                : getDirectSaveValues(confirmFormValues),
            path: { id: rfp.id, lock_id: lockId },
        };
        yield wrapDispatch(dispatch, apiUpdateRfpOfferSave(data, {}));
        if (!unmountRef.current) {
            hideConfirmModal();
            history.push(professionalRfpOfferCompletePath(rfp.id), {
                state: { lockId },
            });
        }
    }), [
        changeStepValue,
        dispatch,
        hideConfirmModal,
        history,
        lockId,
        rfp,
        unmountRef,
    ]);
    /**
     * 保存失敗時の処理
     */
    const onSubmitFail = useCallback(() => {
        hideConfirmModal();
        notify('提案の更新に失敗しました');
    }, [hideConfirmModal]);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main', sticky: _jsx(RfpProConfirmFormButton, { lockId: lockId, onClickSubmit: showConfirmModal, rfpId: rfp.id }), stickyClassName: '!pointer-events-auto' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title}｜PROFFIT` }) }), _jsx(RfpProOfferConfirmView, { budget: rfp.max_budget || rfp.budget, hideModal: hideConfirmModal, initialValues: initialValues, isShowConfirmModal: isShowConfirmModal, onSubmit: onSubmit, onSubmitFail: onSubmitFail, paymentOption: rfp.payment_option, rfpId: rfp.id, rfpName: rfp.name, title: title })] })));
};
